import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RequestModel } from '../typings/typing';
import { BehaviorSubject, Observable } from 'rxjs';
import { NzMessageService } from 'ng-zorro-antd/message';
import { TranslateService } from '@ngx-translate/core';
import { CartService } from './cart.service';
import { CustomerService } from './customer.service';

@Injectable({
  providedIn: 'root'
})
export class WishlistService {
  prefix = '/eshop_backend/wishlistCart';
  private wishItemsSubject = new BehaviorSubject<any[]>([]);
  wishListData$: Observable<any> = this.wishItemsSubject.asObservable();
  constructor(private customerService:CustomerService,private http: HttpClient,private message:NzMessageService,private translate:TranslateService,private  cartService:CartService) {
    this.getWishList({});
    this.customerService.selectedCustomer$.subscribe(() => {
      this.getWishList({});
    });
  }
  moveToCart(params: any) {
    const headers = new HttpHeaders().set('globalLoading', 'true');
    this.http.post<RequestModel>(this.prefix + '/addListToCart', params,{headers}).subscribe(()=>{
      this.message.create(
        'success',
        this.translate.instant('OPERATION_SUCCESS')
      );
      this.getWishList({});
      this.cartService.getListFromCart("create_time","desc");
    })
  }
  deleteAll(params: any) {
    this.http.post<RequestModel>(this.prefix + '/delete', params).subscribe(()=>{
      this.message.create(
        'success',
        this.translate.instant('OPERATION_SUCCESS')
      );
      this.getWishList({});
    });
  }
  updateWishList(product:any){
    let params = {
      id: product.id,
      quantity: product.quantity
    };
    this.http.post(this.prefix + `/update`, params).subscribe(
      () => {
        const currentItems = this.wishItemsSubject.value;
        const updatedItems = currentItems.map((item) => {
          if (item.id === product.id) {
            return { ...item, product}; //Do not pass product, but pass the returned value in order to obtain the latest error result
          } else {
            return item;
          }
        });

        this.wishItemsSubject.next(updatedItems);
      },
      (error) => {
        console.error('Error updating:', error);
      }
    );
  }
  addToWhishList(params: any){
     this.http.post<RequestModel>(this.prefix + '/insert', params) .subscribe(
      () => {
        this.message.create(
          'success',
          this.translate.instant('OPERATION_SUCCESS')
        );
        this.getWishList({});
      });
  }
  getWishList(params: any){
    this.http.get<RequestModel>(this.prefix + '/list', {params}).subscribe((items: RequestModel) => {
      let data = items.rtnData;
      this.wishItemsSubject.next(data);
    })
  }
}
